var _circle, _circle2, _circle3, _line, _line2, _line3, _circle4, _rect, _ellipse, _path, _path2, _path3, _path4, _polygon, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 45,
    r: 5,
    fill: "#22d3ee"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 35,
    r: 5,
    fill: "#22d3ee"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 45,
    r: 5,
    fill: "#22d3ee"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 55,
    x2: 92,
    y2: 70,
    stroke: "#22d3ee",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 48,
    x2: 100,
    y2: 60,
    stroke: "#22d3ee",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 55,
    x2: 108,
    y2: 70,
    stroke: "#22d3ee",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 6,
    fill: "#f97316"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 95,
    width: 8,
    height: 35,
    fill: "#f97316"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 80,
    rx: 45,
    ry: 12,
    fill: "none",
    stroke: "#0ea5e9",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 62 95 Q 100 112 138 95",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 72 110 Q 100 125 128 110",
    fill: "none",
    stroke: "#7dd3fc",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 80 C 55 105 85 110 90 130",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 145 80 C 145 105 115 110 110 130",
    fill: "none",
    stroke: "#e0f2fe",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "88,130 112,130 100,145",
    fill: "#f97316"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 12,
    fill: "#fdba74",
    opacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 7,
    fill: "#fb923c",
    opacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 4,
    fill: "#ea580c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c763e0e1832afd077a08b333b1181f0f.svg";
export { ForwardRef as ReactComponent };